/* Common Imports */

import { makeStyles, withStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */

import { Slider, Typography } from "@material-ui/core";
import ValueLabel from "@material-ui/core/Slider/ValueLabel";

/* Image Imports */

import sixThirtyAM from "../../../public/images/icons/heavie/singleproperty/totd-0630-am.webp";
import fourThirtyPM from "/public/images/icons/heavie/singleproperty/totd-0430-pm.webp";
import sixThirtyPM from "/public/images/icons/heavie/singleproperty/totd-0630-pm.webp";
import eightPM from "/public/images/icons/heavie/singleproperty/totd-0800-pm.webp";
import tenPM from "/public/images/icons/heavie/singleproperty/totd-1000-pm.webp";
import elevenAM from "/public/images/icons/heavie/singleproperty/totd-1100-am.webp";

/* Data Imports */

import AppConfig from "../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    width: "100%",
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      padding: "0rem 0.5rem 1rem 0.5rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0rem 1.5rem 1rem 1.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 3rem 1rem 3rem",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    /* XLG breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
      padding: "0rem 5rem 1rem 5rem",
    },
    /* Full HD breakpoint */
    [theme.breakpoints.up("xl")]: {
      padding: "0rem 23rem 5rem 23rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "0rem 36rem 5rem 36rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "0rem 72rem 5rem 72rem",
    },
    // margin: "0rem 0rem 6rem 0rem",
    [theme.breakpoints.down("sm")]: {
      // margin: "0rem 0rem 2rem 0rem",
    },
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "0.5rem",
    margin: "2rem 0rem 2rem 0rem",
    [theme.breakpoints.down("sm")]: {
      margin: "0rem 0rem 0rem 0rem",
    },
  },
  heading: {
    width: "100%",
    color: "#693471",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  illustrationSizer: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    marginBottom: "1.5rem",
    borderRadius: "1rem",
  },
  sliderDesktop: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    "& .MuiSlider-root": {
      cursor: "none",
    },
    "& .MuiSlider-rail": {
      backgroundColor: "#4a225b",
      opacity: 0.5,
      zIndex: 1,
      cursor: "none",
    },
    "& .MuiSlider-track": {
      color: "#4a225b",
      zIndex: 1,
      cursor: "none",
    },
    "& .MuiSlider-markLabel": {
      '&[data-index="0"]': {
        display: "none",
        marginLeft: "2rem",
      },
      '&[data-index="1"]': {
        display: "none",
      },
      '&[data-index="2"]': {
        display: "none",
      },
      '&[data-index="3"]': {
        display: "none",
      },
      '&[data-index="4"]': {
        display: "none",
      },
      '&[data-index="5"]': {
        display: "none",
        marginLeft: "-2rem",
      },
    },
    "& .MuiSlider-mark": {
      height: "2rem",
      width: "2rem",
      borderRadius: "50%",
      marginLeft: "-1rem",
      marginTop: "-1rem",
      zIndex: 2,
      backgroundColor: "#FFFFFF",
      backgroundImage: `url(/images/icons/heavie/singleproperty/time/1.svg)`,
      backgroundSize: "2rem 2rem",
      backgroundRepeat: "no-repeat",
    },
    "& .MuiSlider-markActive": {
      opacity: 1,
      // height: "2rem",
      // width: "2rem",
      // borderRadius: "50%",
      // marginLeft: "-1rem",
      // marginTop: "-1rem",
      // zIndex: 2,
      // backgroundColor: "#FFFFFF",
      // backgroundImage: `url(/images/icons/heavie/singleproperty/time/1.svg)`,
      // backgroundSize: "2rem 2rem",
      // backgroundRepeat: "no-repeat",
    },
    "& .MuiSlider-thumb": {
      display: "none",
    },
    "& .MuiSlider-valueLabel": {
      left: "-20.5px",
    },
    // "& > span > span > span": {
    //   color: "orange",
    //   borderRadius: "0",
    //   fontWeight: 800,
    // },
  },
  slider: {
    "& .MuiSlider-root": {
      height: 8,
    },
    "& .MuiSlider-rail": {
      height: 8,
      borderRadius: 4,
    },
    "& .MuiSlider-track": {
      height: 8,
      borderRadius: 4,
    },
    "& .MuiSlider-markLabel": {
      '&[data-index="0"]': {
        // display: "none",
        marginLeft: "2rem",
      },
      '&[data-index="1"]': {
        display: "none",
      },
      '&[data-index="2"]': {
        display: "none",
      },
      '&[data-index="3"]': {
        display: "none",
      },
      '&[data-index="4"]': {
        display: "none",
      },
      '&[data-index="5"]': {
        // display: "none",
        marginLeft: "-2rem",
      },
    },
    "& .MuiSlider-mark": {
      display: "none",
    },
    "& .MuiSlider-thumb": {
      height: 24,
      width: 24,
      backgroundColor: "#fff",
      border: "2px solid currentColor",
      marginTop: -8,
      marginLeft: -12,
    },
    "& .MuiSlider-valueLabel": {
      left: "-20.5px",
    },
    // "& > span > span > span": {
    //   color: "orange",
    //   borderRadius: "0",
    //   fontWeight: 800,
    // },
  },
}));

const StyledValueLabel = withStyles({
  circle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 65,
    height: 30,
    borderRadius: 0,
    backgroundColor: "#4a225b",
    transform: "rotate(0deg)",
  },
  label: {
    color: "#ffffff",
    transform: "rotate(0deg)",
  },
})(ValueLabel);

const TimeOfTheDay = () => {
  const classes = useStyles();
  const [imgSrc, setImgSrc] = React.useState(elevenAM.src);

  const marks = [
    {
      value: 630,
      label: "06:00 AM",
      src: sixThirtyAM.src,
    },
    {
      value: 1100,
      label: "10:00 AM",
      src: elevenAM.src,
    },
    {
      value: 1630,
      label: "04:30 PM",
      src: fourThirtyPM.src,
    },
    {
      value: 1830,
      label: "06:00 PM",
      src: sixThirtyPM.src,
    },
    {
      value: 2000,
      label: "08:00 PM",
      src: eightPM.src,
    },
    {
      value: 2200,
      label: "10:00 PM",
      src: tenPM.src,
    },
  ];

  return (
    <React.Fragment>
      <div className={classes.megaContainer}>
        <div className={classes.sectionContainer}>
          <Typography
            variant="h1"
            component="h1"
            className={classes.heading}
          >
            Time of the day
          </Typography>
          <img
            src={imgSrc}
            alt={AppConfig.imageAltText}
            width={512}
            height={512}
            loading="eager"
            referrerPolicy="no-referrer"
            className={classes.illustrationSizer}
          />

          {/* Desktop */}
          {/* <Slider
            className={classes.sliderDesktop}
            aria-label="Time of the day"
            min={630}
            max={2200}
            defaultValue={1100}
            step={null}
            marks={marks}
            onChange={(e, value) => {
              const newImgSrc = marks.find((mark) => mark.value === value).src;
              setImgSrc(newImgSrc);
            }}

            // ValueLabelComponent={StyledValueLabel}
            // valueLabelFormat={(value) => {
            //   const tooltip = marks.find((mark) => mark.value === value).label;
            //   return tooltip;
            // }}
            // valueLabelDisplay="auto"
          /> */}

          {/* Phone */}
          <Slider
            className={classes.slider}
            aria-label="Time of the day"
            min={630}
            max={2200}
            defaultValue={1100}
            step={null}
            marks={marks}
            onChange={(e, value) => {
              const newImgSrc = marks.find((mark) => mark.value === value).src;
              setImgSrc(newImgSrc);
            }}
            ValueLabelComponent={StyledValueLabel}
            valueLabelFormat={(value) => {
              const tooltip = marks.find((mark) => mark.value === value).label;
              return tooltip;
            }}
            valueLabelDisplay="on"
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default TimeOfTheDay;
